import React from 'react';
import { AiOutlineShoppingCart, AiOutlineDashboard, AiOutlineLogout } from 'react-icons/ai';
import { IoMdContacts } from 'react-icons/io';
import { RiContactsLine, RiPriceTag2Line } from 'react-icons/ri';
import { BsCurrencyDollar, BsShield } from 'react-icons/bs';
import { FiCreditCard } from 'react-icons/fi';
import { TiTick } from 'react-icons/ti';
import { MdCampaign } from 'react-icons/md';

// Color primario de marca — fuente única de verdad
export const BRAND_COLOR = '#FF743A';

const avatar = '/avatars/avatar.jpg';
const avatar2 = '/avatars/avatar.jpg';
const avatar3 = '/avatars/avatar.jpg';
const avatar4 = '/avatars/avatar.jpg';

// --- Sidebar ---

export const links = [
  {
    title: 'menu_principal',
    links: [
      { name: 'dashboard', icon: <AiOutlineDashboard /> },
      { name: 'cotizaciones', icon: <RiPriceTag2Line /> },
      { name: 'ordenes', icon: <AiOutlineShoppingCart /> },
      { name: 'agenda', icon: <IoMdContacts /> },
      { name: 'instalacion', icon: <IoMdContacts /> },
      { name: 'stock', icon: <RiContactsLine /> },
      { name: 'clientes', icon: <AiOutlineShoppingCart /> },
      { name: 'finanzas', icon: <IoMdContacts /> },
      { name: 'marketing', icon: <MdCampaign /> },
      { name: 'seguridad', icon: <RiContactsLine /> },
      { name: 'cerrar_sesion', icon: <AiOutlineLogout />, action: 'logout' },
    ],
  },
];

// --- Dashboard ---

export const recentTransactions = [
  { icon: <BsCurrencyDollar />, amount: '+$350', title: 'Deposito', desc: 'Ingreso de dinero', iconColor: '#03C9D7', iconBg: '#E5FAFB', pcColor: 'green-600' },
  { icon: <BsShield />, amount: '-$560', title: 'Wallet', desc: 'Wallet', iconColor: 'rgb(0, 194, 146)', iconBg: 'rgb(235, 250, 242)', pcColor: 'red-600' },
  { icon: <FiCreditCard />, amount: '+$350', title: 'Tarjeta de Credito', desc: 'Pago por validar', iconColor: 'rgb(255, 244, 229)', iconBg: 'rgb(254, 201, 15)', pcColor: 'green-600' },
  { icon: <TiTick />, amount: '+$350', title: 'Transferencia Bancaria', desc: 'Ingreso de dinero', iconColor: 'rgb(228, 106, 118)', iconBg: 'rgb(255, 244, 229)', pcColor: 'green-600' },
  { icon: <BsCurrencyDollar />, amount: '-$50', title: 'Devolución', desc: 'Pago Enviado', iconColor: '#03C9D7', iconBg: '#E5FAFB', pcColor: 'red-600' },
];

export const recentCotizaciones = [
  { icon: avatar, estado: 'Aceptada', title: 'Sebastian Valenzuela', desc: '+5695265842', iconColor: '#03C9D7', iconBg: '#E5FAFB', pcColor: 'green-600' },
  { icon: avatar2, estado: 'Aceptada', title: 'Jorge González', desc: '+5695878984', iconColor: 'rgb(0, 194, 146)', iconBg: 'rgb(235, 250, 242)', pcColor: 'green-600' },
  { icon: avatar3, estado: 'Cancelada', title: 'Cristina Morales', desc: '+569587984', iconColor: 'rgb(255, 244, 229)', iconBg: 'rgb(254, 201, 15)', pcColor: 'red-600' },
  { icon: avatar4, estado: 'Aceptada', title: 'Verónica Moya', desc: '+5695878984', iconColor: 'rgb(228, 106, 118)', iconBg: 'rgb(255, 244, 229)', pcColor: 'green-600' },
  { icon: avatar3, estado: 'Pendiente', title: 'Ricardo Reyes', desc: '+5695878984', iconColor: '#03C9D7', iconBg: '#E5FAFB', pcColor: 'yellow-500' },
];

export const ecomPieChartData = [
  { x: 'Instagram', y: 18, text: '43%', color: '#E1306C' },
  { x: 'Web', y: 18, text: '17%', color: '#007BFF' },
  { x: 'WhatsApp', y: 18, text: '40%', color: '#25D366' },
];

export const LinePrimaryXAxis = {
  valueType: 'DateTime',
  labelFormat: 'MMM',
  intervalType: 'Months',
  edgeLabelPlacement: 'Shift',
  majorGridLines: { width: 0 },
  background: 'white',
};

export const LinePrimaryYAxis = {
  labelFormat: '{value}',
  rangePadding: 'None',
  minimum: 0,
  maximum: 100,
  interval: 20,
  lineStyle: { width: 0 },
  majorTickLines: { width: 0 },
  minorTickLines: { width: 0 },
};

const lineChartData = [
  [
    { x: new Date(2024, 0, 1), y: 21 }, { x: new Date(2024, 1, 1), y: 24 },
    { x: new Date(2024, 2, 1), y: 36 }, { x: new Date(2024, 3, 1), y: 38 },
    { x: new Date(2024, 4, 1), y: 54 }, { x: new Date(2024, 5, 1), y: 30 },
    { x: new Date(2024, 6, 1), y: 10 },
  ],
  [
    { x: new Date(2024, 0, 1), y: 15 }, { x: new Date(2024, 1, 1), y: 28 },
    { x: new Date(2024, 2, 1), y: 44 }, { x: new Date(2024, 3, 1), y: 48 },
    { x: new Date(2024, 4, 1), y: 50 }, { x: new Date(2024, 5, 1), y: 66 },
    { x: new Date(2024, 6, 1), y: 78 },
  ],
  [
    { x: new Date(2024, 0, 1), y: 10 }, { x: new Date(2024, 1, 1), y: 10 },
    { x: new Date(2024, 2, 1), y: 20 }, { x: new Date(2024, 3, 1), y: 30 },
    { x: new Date(2024, 4, 1), y: 39 }, { x: new Date(2024, 5, 1), y: 50 },
    { x: new Date(2024, 6, 1), y: 15 },
  ],
];

export const lineCustomSeries = [
  { dataSource: lineChartData[0], xName: 'x', yName: 'y', name: 'Silver Espejadas', width: '2', marker: { visible: true, width: 10, height: 10 }, type: 'Line' },
  { dataSource: lineChartData[1], xName: 'x', yName: 'y', name: 'Optivision', width: '2', marker: { visible: true, width: 10, height: 10 }, type: 'Line' },
  { dataSource: lineChartData[2], xName: 'x', yName: 'y', name: 'Premium Nova', width: '2', marker: { visible: true, width: 10, height: 10 }, type: 'Line' },
];

const gananciasMensualesData = [
  [
    { x: 'Ene', y: 111.1 }, { x: 'Feb', y: 127.3 }, { x: 'Mar', y: 143.4 },
    { x: 'Apr', y: 159.9 }, { x: 'May', y: 159.9 }, { x: 'Jun', y: 159.9 },
    { x: 'Jul', y: 159.9 },
  ],
];

export const gananciasMensuales = [
  { dataSource: gananciasMensualesData[0], xName: 'x', yName: 'y', name: 'Ganancias', type: 'StackingColumn', fill: '#FF743A' },
];

const IngresosEgresosData = [
  [
    { x: 'Ene', y: 111.1 }, { x: 'Feb', y: 127.3 }, { x: 'Mar', y: 143.4 },
    { x: 'Apr', y: 159.9 }, { x: 'May', y: 159.9 }, { x: 'Jun', y: 159.9 },
    { x: 'Jul', y: 159.9 },
  ],
  [
    { x: 'Ene', y: 111.1 }, { x: 'Feb', y: 127.3 }, { x: 'Mar', y: 143.4 },
    { x: 'Apr', y: 159.9 }, { x: 'May', y: 159.9 }, { x: 'Jun', y: 159.9 },
    { x: 'Jul', y: 159.9 },
  ],
];

export const IngresosEgresos = [
  { dataSource: IngresosEgresosData[0], xName: 'x', yName: 'y', name: 'Ingresos', type: 'StackingColumn', fill: '#FF743A' },
  { dataSource: IngresosEgresosData[1], xName: 'x', yName: 'y', name: 'Gastos', type: 'StackingColumn', fill: '#3B82F6' },
];

export const stackedPrimaryXAxis = {
  majorGridLines: { width: 0 },
  minorGridLines: { width: 0 },
  majorTickLines: { width: 0 },
  minorTickLines: { width: 0 },
  interval: 1,
  lineStyle: { width: 0 },
  labelIntersectAction: 'Rotate45',
  valueType: 'Category',
};

export const stackedPrimaryYAxis = {
  lineStyle: { width: 0 },
  minimum: 0,
  maximum: 400,
  interval: 100,
  majorTickLines: { width: 0 },
  majorGridLines: { width: 1 },
  minorGridLines: { width: 1 },
  minorTickLines: { width: 0 },
  labelFormat: '{value}',
};
